import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const LanguageSelector = () => {
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Language Selector | BingeBit";
    }, [])

    useEffect(() => {
        document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    }, [i18n.language]);

    const styles = `
    .language-selector-container {
      color: white;
      padding: 20px;
      width: 100%;
      max-width: 360px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .language-title {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 30px;
      margin-top: 20px;
    }
    .language-buttons {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;
    }
    .language-btn {
      background-color: #FFDD00;
      color: #252525;
      border: none;
      border-radius: 20px;
      padding: 12px 28px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      transition: background 0.2s;
    }
    .language-btn.selected {
      background-color: #ffe95c;
      border: 2px solid #252525;
    }
    .back-btn {
      margin-top: 30px;
      background: none;
      color: #FFDD00;
      border: none;
      font-size: 16px;
      cursor: pointer;
      text-decoration: underline;
    }
  `;

    const handleLanguageChange = (lng) => {
        i18n.changeLanguage(lng);
        document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
        localStorage.setItem('language', lng);
    };

    return (
        <>
            <style>{styles}</style>
            <div className="language-selector-container">
                <div className="language-title">{t('select_language') || 'Select Language'}</div>
                <div className="language-buttons">
                    <button
                        className={`language-btn${i18n.language === 'en' ? ' selected' : ''}`}
                        onClick={() => handleLanguageChange('en')}
                    >
                        English
                    </button>
                    <button
                        className={`language-btn${i18n.language === 'ar' ? ' selected' : ''}`}
                        onClick={() => handleLanguageChange('ar')}
                    >
                        العربية
                    </button>
                </div>
                <button className="back-btn" onClick={() => navigate(-1)}>
                    {t('back') || 'Back'}
                </button>
            </div>
        </>
    );
};

export default LanguageSelector;
